<kt-portlet class="knostos-grid">
  <!-- PORTLET LOADING | Binded to TABLE Datasource -->
  <!-- See prop => '~/core/_crud/models/data-sources/_base.datasource.ts' (loading$) -->
  <kt-portlet-header title="" [class]="'card-head-lg'" [viewLoading$]="dataSource?.loading$">
    <ng-container ktPortletTitle>
      <span translate="PATIENT.INPUT.INSURANCE.INSURANCE_LIST">Insurance List</span>
    </ng-container>
    <ng-container ktPortletTools>
      <div>
        <button
          type="button"
          *ngIf="!isReadOnly"
          (click)="addInsurance()"
          mat-raised-button
          color="primary"
          matTooltip="Create new Insurance"
        >
          <span inlineSVG="./assets/media/svg/icons/General/add_circle_icon.svg"></span>
          New Insurance
        </button>
      </div>
    </ng-container>
  </kt-portlet-header>
  <!-- end::Header -->

  <!-- start::Body (attribute: ktPortletBody) -->
  <kt-portlet-body>
    <div class="mat-table-wrapper">
      <mat-table [dataSource]="dataSource" matSort #sort="matSort" class="lmat-elevation-z8">
        <!-- Position Column -->
        <ng-container matColumnDef="insurance_id">
          <mat-header-cell mat-sort-header *matHeaderCellDef>
            {{ 'PATIENT.INPUT.INSURANCE.INSURANCE_ID' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{ element.insurance.id }} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="insurance_no">
          <mat-header-cell mat-sort-header *matHeaderCellDef>
            {{ 'PATIENT.INPUT.INSURANCE.INSURANCE_NUMBER' | translate }}
          </mat-header-cell>
          <mat-cell
            *matCellDef="let element"
            class="clickable"
            matTooltip="View Insurance"
            (dblclick)="addInsurance(element, true)"
          >
            {{ element.insurance_no }}
          </mat-cell>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="insurance_name">
          <mat-header-cell mat-sort-header *matHeaderCellDef>
            {{ 'PATIENT.INPUT.INSURANCE.PLAN_NAME' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{ element.insurance.name }} </mat-cell>
        </ng-container>

        <!-- Weight Column -->
        <ng-container matColumnDef="group_no">
          <mat-header-cell mat-sort-header *matHeaderCellDef>
            {{ 'PATIENT.INPUT.INSURANCE.GROUP' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{ element.group_no }} </mat-cell>
        </ng-container>

        <!-- Symbol Column -->
        <ng-container matColumnDef="person_code">
          <mat-header-cell mat-sort-header *matHeaderCellDef>
            {{ 'PATIENT.INPUT.INSURANCE.PERSON_CODE' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{ element.person_code }} </mat-cell>
        </ng-container>

        <!-- Symbol Column -->
        <ng-container matColumnDef="priority">
          <mat-header-cell mat-sort-header *matHeaderCellDef>
            {{ 'PATIENT.INPUT.INSURANCE.PRIORITY' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{ element.priority }} </mat-cell>
        </ng-container>

        <!-- Symbol Column -->
        <ng-container matColumnDef="is_active">
          <mat-header-cell mat-sort-header *matHeaderCellDef>
            {{ 'PATIENT.INPUT.INSURANCE.STATUS' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <span
              class="label label-lg label-light-{{
                getItemCssClassByStatus(element.is_active)
              }} label-inline"
              >{{ getItemStatusString(element.is_active) }}</span
            >
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef class="mat-column-actions" translate="TABLE.ACTIONS">
            Actions
          </mat-header-cell>
          <mat-cell *matCellDef="let element" class="mat-column-actions">
            <button
              *ngIf="isReadOnly"
              color="success"
              matTooltip="{{ 'TABLE.VIEW' | translate }} Insurance"
              (click)="addInsurance(element)"
              class="btn btn-icon btn-light btn-hover-success btn-sm"
            >
              <span class="svg-icon svg-icon-md svg-icon-success">
                <span inlineSVG="./assets/media/svg/icons/General/visible.svg"></span>
              </span>
            </button>
            <button
              *ngIf="!isReadOnly"
              color="primary"
              matTooltip="{{ 'TABLE.UPDATE' | translate }} Insurance"
              (click)="addInsurance(element)"
              class="btn btn-icon btn-light btn-hover-primary btn-sm margin-2"
            >
              <span class="svg-icon svg-icon-md svg-icon-primary">
                <span inlineSVG="./assets/media/svg/icons/General/edit_icon.svg"></span>
              </span>
            </button>
            <button
              *ngIf="!isReadOnly"
              color="danger"
              matTooltip="{{ 'TABLE.DELETE' | translate }} Insurance"
              (click)="deletePatientInsurance(element)"
              class="btn btn-icon btn-light btn-hover-danger btn-sm margin-2"
            >
              <span class="svg-icon svg-icon-md svg-icon-danger">
                <span inlineSVG="./assets/media/svg/icons/General/delete_icon.svg"></span>
              </span>
            </button>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns" class="sticky-header"></mat-header-row
        >&nbsp;

        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>

      <div
        class="mat-table__message"
        *ngIf="!dataSource?.hasItems && !(dataSource?.isPreloadTextViewed$ | async)"
      >
        {{ 'TABLE.NO_RECORDS' | translate }}
      </div>
      <!-- Message for empty data  -->
      <div class="mat-table__message" *ngIf="dataSource?.isPreloadTextViewed$ | async">
        {{ 'TABLE.PLAESE_WAIT' | translate }}
      </div>
    </div>

    <!-- start: BOTTOM -->
    <div class="mat-table__bottom">
      <!-- MATERIAL SPINNER | Url: 'https://material.angular.io/components/progress-spinner/overview' -->
      <mat-spinner [diameter]="20" *ngIf="dataSource?.loading$ | async"></mat-spinner>
      <!-- MATERIAL PAGINATOR | Binded to dasources -->
      <!-- See off.documentations 'https://material.angular.io/components/paginator/overview' -->
    </div>
    <!-- end: BOTTOM -->
  </kt-portlet-body>
  <!-- end::Body -->
  <kt-portlet-footer>
    <div class="mat-table__bottom">
      <mat-paginator
        [pageSize]="10"
        [pageSizeOptions]="[10, 25, 50, 200]"
        [length]="dataSource?.paginatorTotal$ | async"
        [showFirstLastButtons]="true"
      ></mat-paginator>
    </div>
  </kt-portlet-footer>
</kt-portlet>
